/**
* Globe JS
* -----------------------------------------------------------------------------
*
* All the JS for the Globe component.
*/
import {OrbitControls} from 'three/examples/js/controls/OrbitControls';

( function( app ) {
  const COMPONENT = {

    className: 'll-globe',
    dataset: {
      lat: 26.1420,
      lng: 81.7948,
    },
    globe: null,
    camera: null,
    radius: null,
    locationStore: [],
    scene: null,
    controls: null,
    center: null,
    startingPos: {
      lng: -94.578568,
      lat: 39.099728,
    },

    selector: function() {
      return '.' + this.className;
    },

    distanceFromCamera: function() {
      const globe = this.globe;
      const camera = this.camera;
      const radius = this.radius;
      const a = globe.position.clone().sub( camera.position );
      const distance = Math.sqrt( Math.pow( a.length(), 2 ) - Math.pow( radius, 2 ) );
      return distance;
    },

    toggleVisibility: function( location, marker, distanceFromCamera ) {
      const camera = this.camera;
      const objectDistance = location.position.clone().sub( camera.position );
      const objectHidden = objectDistance.length() > distanceFromCamera;

      marker.data( 'hidden', objectHidden ).toggleClass( 'behind', objectHidden );
    },

    toggleLeftRight: function( location, marker, distanceFromCamera ) {
      const camera = this.camera;
      const objectDistance = location.position.clone().sub( camera.position );
      const isLeft = objectDistance.x > 0;


      marker.data( 'hidden', isLeft ).toggleClass( 'is-left', isLeft );
    },

    convertLatLng: function( lat, lng ) {
      const radius = this.radius;
      const position = {};
      // convert lat lng to x y z
      const phi = ( 90-lat )*( Math.PI/180 );
      const theta = ( lng+180 )*( Math.PI/180 );

      position.x = -( ( radius ) * Math.sin( phi )*Math.cos( theta ) );
      position.y = ( ( radius ) * Math.cos( phi ) );
      position.z = ( ( radius ) * Math.sin( phi )*Math.sin( theta ) );

      return position;
    },

    // Fires after common.init, before .finalize and common.finalize

    init: function() {
      const points = document.querySelectorAll( '.circle' );
      const popupWrapper = document.querySelectorAll( '.popup-wrapper' );
      const markerContainer = document.querySelectorAll( '.marker-container' );
      const markerLi = document.querySelectorAll( 'li.marker.pulsing' );
      const exit = document.querySelectorAll( '.globe-popup.exit' );
      const marker = document.querySelectorAll( '.marker.pulsing' );

      exit.forEach( ( x, idx ) => {
        x.addEventListener( 'click', () => {
          clearPopups();
          clearRedMarkers();
          clearMarkerClass();
        } );
      } );

      marker.forEach( ( x, idx ) => {
        x.addEventListener( 'click', () => {
          x.classList.add( 'mobile-center' );
        } );
      } );

      const clearPopups = () => {
        popupWrapper.forEach( ( popup, idx ) => {
          popup.classList.remove( 'active' );
        } );
      };

      const clearRedMarkers = () => {
        markerContainer.forEach( ( mkr, idx ) => {
          mkr.classList.remove( 'active' );
        } );
      };

      const clearMarkerClass = () => {
        marker.forEach( ( mc, idx ) => {
          console.log( mc );
          mc.classList.remove( 'mobile-center' );
        } );
      };


      // load with random timing so animations are spaced
      markerContainer.forEach( ( mc, idx ) => {
        setInterval( () => {
          markerContainer[idx].classList.add( 'loaded' );
        }, Math.floor( Math.random() * 1500 ) );
      } );

      points.forEach( ( point, idx ) => {
        point.addEventListener( 'click', () => {
          if ( popupWrapper[idx].classList.contains( 'active' ) ) {
            clearPopups();
            clearRedMarkers();
            clearMarkerClass();
          } else {
            clearPopups();
            clearRedMarkers();
            clearMarkerClass();
            popupWrapper[idx].classList.add( 'active' );
            markerContainer[idx].classList.add( 'active' );
            markerLi[idx].classList.add( 'active' );
          }
        } );
      } );


      const _this = this;
      const markerOffset = $( '.marker' ).first().outerWidth() / 2;

      function toScreenPosition( obj, camera ) {
        const vector = new THREE.Vector3();

        const globe = document.querySelector( '.globe' );
        const width = globe.offsetWidth;

        const widthHalf = 0.5*width;
        const heightHalf = 0.5*width;

        obj.updateMatrixWorld();
        vector.setFromMatrixPosition( obj.matrixWorld );
        vector.project( camera );

        vector.x = ( vector.x * widthHalf ) + widthHalf;
        vector.y = - ( vector.y * heightHalf ) + heightHalf;

        return {
          x: vector.x - markerOffset,
          y: vector.y - markerOffset,
        };
      }


      // create scene
      _this.scene = new THREE.Scene();
      let autorotateTimeout = false;

      const container = document.getElementById( 'globe' );

      // create camera
      const camera = new THREE.PerspectiveCamera( 75, container.offsetWidth / container.offsetHeight, 0.1, 50 );
      _this.camera = camera;
      _this.camera.position.z = 25.5;
      _this.camera.updateMatrixWorld();

      _this.center = new THREE.Vector3( 0, 0, 0 );

      // var helper = new THREE.CameraHelper( camera );
      // scene.add( helper );

      // create renderer
      const renderer = new THREE.WebGLRenderer( {alpha: true, antialias: true} );
      renderer.setPixelRatio( window.devicePixelRatio );
      renderer.setSize( container.offsetWidth, container.offsetHeight );
      container.appendChild( renderer.domElement );

      // setup controls
      _this.controls = new THREE.OrbitControls( _this.camera, renderer.domElement );
      _this.controls.enableZoom = false;
      _this.controls.enablePan = false;
      _this.controls.rotateSpeed = 0.15;
      _this.controls.enableDamping = true;
      _this.controls.dampingFactor = 0.25;
      _this.controls.autoRotate = false;
      _this.controls.autoRotateSpeed = 0.25;

      // stop autorotate after the first interaction
      $( _this.controls ).on( 'start', function( event ) {
        if ( autorotateTimeout ) {
          clearTimeout( autorotateTimeout );
        }

        _this.controls.autoRotate = false;
      } );

      $( _this.controls ).on( 'update', function( event ) {
        $( document ).trigger( 'updateMarkers', [this, _this.locationStore] );
      } );

      $( _this.controls ).on( 'change', function( event ) {
        $( document ).trigger( 'updateMarkers', [this, _this.locationStore] );
      } );

      // restart autorotate after the last interaction & an idle time has passed
      $( _this.controls ).on( 'end', function( event ) {
        autorotateTimeout = setTimeout( function() {
          _this.controls.autoRotate = false;
        }, 10000 );
      } );

      // turn on the lights
      const lights = [];
      lights[0] = new THREE.SpotLight( 0xffffff, 1, 0 );
      lights[1] = new THREE.AmbientLight( 0xffffff, 5 );

      lights[0].position.copy( _this.camera.position );

      _this.scene.add( lights[0] );
      _this.scene.add( lights[1] );

      // sphere data
      const data = {
        radius: 15,
        widthSegments: 32,
        heightSegments: 32,
      };

      _this.radius = data.radius;

      const mesh = new THREE.Object3D();
      const globe = new THREE.SphereBufferGeometry( data.radius, data.widthSegments, data.heightSegments );

      mesh.add( new THREE.Mesh(
          globe,
          new THREE.MeshPhongMaterial( {
            color: 0x303030,
            side: THREE.DoubleSide,
            map: new THREE.TextureLoader().load( site_info.url + '/wp-content/themes/heart-to-heart/assets/img/globe/earth.jpg' ),
          } )

      ) );

      _this.globe = mesh;

      // add starting vector to point the camera at.
      // in this case we're pointing it at the US
      const startingPoint = _this.convertLatLng( _this.startingPos.lat, _this.startingPos.lng );
      const startingMesh = new THREE.Mesh( new THREE.BoxGeometry( 0.0625, 0.0625, 5 ), new THREE.MeshBasicMaterial( {wireframe: true, transparent: true, opacity: 0} ) );
      startingMesh.position.set( startingPoint.x, startingPoint.y, startingPoint.z );
      startingMesh.lookAt( _this.center );
      _this.scene.add( startingMesh );

      _this.scene.add( mesh );
      const prevFog = false;

      const camDistance = _this.camera.position.length();
      _this.camera.position.copy( startingMesh.position ).normalize().multiplyScalar( camDistance );
      _this.controls.update();
      $( _this.controls ).trigger( 'change' );

      const render = function() {
        requestAnimationFrame( render );
        _this.controls.update();

        // move the light to the camera to make it look like
        // the globe is rotating instead of the camera
        lights[0].position.copy( _this.camera.position );
        renderer.render( _this.scene, _this.camera );
      };


      window.addEventListener( 'resize', function() {
        _this.camera.aspect = container.offsetWidth / container.offsetHeight;
        _this.camera.updateProjectionMatrix();

        renderer.setSize( container.offsetWidth, container.offsetHeight );
      }, false );


      render();

      $( document ).on( 'updateMarkers', function( event, orbit, locations ) {
        clearPopups();
        clearRedMarkers();
        clearMarkerClass();

        $( '.marker' ).each( function( index, el ) {
          const position = toScreenPosition( locations[index], _this.camera );

          const distanceFromCamera = _this.distanceFromCamera();

          // position the overlay so that it's center is on top of
          // the sphere we're tracking

          $( el ).css( {
            transform: 'translate('+position.x+'px, '+position.y+'px)',
          } );

          _this.toggleVisibility( locations[index], $( el ), distanceFromCamera );

          _this.toggleLeftRight( locations[index], $( el ), distanceFromCamera );
        } );
      } );

      // THREE.DefaultLoadingManager.onStart = function( url, itemsLoaded, itemsTotal ) {
      //   console.log( 'Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
      // };

      THREE.DefaultLoadingManager.onLoad = function( ) {
        // console.log( 'Loading Complete!' );
        $( '.ll-globe' ).addClass( 'loaded' );

        // set up the vectors for each point
        $( '.marker' ).each( function( index, el ) {
          const lat = parseFloat( $( this ).data( 'lat' ) );
          const lng = parseFloat( $( this ).data( 'lng' ) );
          // convert lat lng to x y z

          const newPosition = _this.convertLatLng( lat, lng );

          // setup the vector
          const item = new THREE.Mesh( new THREE.BoxGeometry( 0.0625, 0.0625, 5 ), new THREE.MeshBasicMaterial( {wireframe: true, transparent: true, opacity: 0} ) );

          item.position.set( newPosition.x, newPosition.y, newPosition.z );

          const position = toScreenPosition( item, _this.camera );

          // position the overlay so that it's center is on top of
          // the sphere we're tracking


          $( el ).css( {
            transform: 'translate('+position.x+'px, '+position.y+'px)',
          } );

          if ( newPosition.z < 0 ) {
            $( el ).addClass( 'behind' );
          }

          if ( newPosition.x > 0 ) {
            $( el ).addClass( 'is-left' );
          }

          item.lookAt( _this.center );
          _this.scene.add( item );
          _this.locationStore.push( item );
        } );
      };

      // THREE.DefaultLoadingManager.onProgress = function( url, itemsLoaded, itemsTotal ) {
      //   console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
      // };

      // THREE.DefaultLoadingManager.onError = function( url ) {
      //   console.log( 'There was an error loading ' + url );
      // };

      $( '.marker a' ).click( function( e ) {
        e.preventDefault();
        // var locationKey = $(this).data('index');
        // var location = _this.locationStore[locationKey];

        // var camDistance = _this.camera.position.length();
        // _this.camera.position.copy( location.position ).normalize().multiplyScalar(camDistance);
        // _this.controls.update();
      } );
    },


    finalize: function() {
      const _this = this;
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'globe', COMPONENT );
} )( app );
